export default class ClubActionLogEntry {

    static fromData(data) {
        if (!data) {
            return;
        }

        let logEntry = new ClubActionLogEntry();

        if (!data.id) {
            return logEntry;
        }

        logEntry.id = data.id;

        logEntry.createdByLastName = data.createdByLastName;
        logEntry.createdByFirstName = data.createdByFirstName;
        logEntry.event = data.event;
        logEntry.createdAtDate = data.createdAtDate;
        logEntry.createdAtTime = data.createdAtTime;

        return logEntry;
    }
}
